import "./Sidebar.css";
import { useAuth } from "@/hooks/useAuth";
import { Link } from "react-router-dom";

import Logo from "@/assets/img/logoC3S.jpeg";
import { LogOut, Users } from "lucide-react";

export const SidebarDashboard = () => {
  const { userContext, logout } = useAuth();

  return (
    <div className="menu_box">
      <div className="flex place-content-center mb-10">
      <div className="size-20">
        <img
          src={Logo}
          alt="Dashboard Icon"
          className="logo size-full rounded-md"
        />
      </div>
      </div>
      <div className="borderMenu"/>
      <div className="menu_entete">
        <h4>
          <strong>Portail Administrateur</strong>
        </h4>
        <p className="mb-10">{userContext?.firstName}</p>
      </div>
        <div className="borderMenu"/>
      <h4>
        <strong>MENU</strong>
      </h4>
      <div className="menu_section">
        <ul>
          <li>
            <Link className="menu_item gap-8" to="/dashboard/licences">
            <Users />              <p className="font-medium">Gestion des comptes</p>
            </Link>
          </li>
          <li>
            <Link
              className="menu_item menu_item2 gap-8"
              to="/connexion"
              onClick={() => logout()}
            >
              <LogOut className="size-5"/> <p className="font-normal">Se déconnecter</p>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};